import 'moment/locale/pt-br';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import ThemeProvider from './Contexts/ThemeProvider';
import AppProvider from './Contexts/AppProvider';
import RegisterProvider from './Contexts/RegisterProvider';

import Init from './Pages/Init';

function App() {
  return (
    <div className="App">
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <ThemeProvider>
          <AppProvider>
            <RegisterProvider>
              <Init />
            </RegisterProvider>
          </AppProvider>
        </ThemeProvider>
      </LocalizationProvider>
    </div>
  );
}

export default App;
